module.exports = __webpack_public_path__ + "static/BFSI-2020-f660c11964e129a10d7490ad0ea56f39.png";